const StudentOutcomes = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Measurable Impact
          </h2>
          <p className="text-base text-gray-300 max-w-3xl mx-auto">
            Real results from schools across India
          </p>
        </div>

        {/* Top Metrics Bar */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-16">
          {[
            { number: '5,000+', label: 'Students Impacted', trend: '+25%', icon: 'ri-user-star-line' },
            { number: '95%', label: 'Parent Satisfaction', trend: '+5%', icon: 'ri-heart-line' },
            { number: '12,000+', label: 'Projects Completed', trend: '+30%', icon: 'ri-file-list-3-line' }
          ].map((stat, idx) => (
            <div
              key={idx}
              className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 hover:bg-white/20 transition-all"
            >
              <i className={`${stat.icon} text-2xl text-blue-400 mb-2`}></i>
              <div className="text-3xl font-bold text-white mb-1">{stat.number}</div>
              <div className="text-sm text-gray-300 mb-2">{stat.label}</div>
              <div className="flex items-center gap-1 text-green-400 text-sm">
                <i className="ri-arrow-up-line"></i>
                <span>{stat.trend}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StudentOutcomes;
